// src/pages/KvkkNotice.jsx
import LegalLayout from "../components/LegalLayout";

export default function KvkkNotice() {
  return (
    <LegalLayout
      title="KVKK Aydınlatma Metni"
      updatedAt="18.12.2025"
      subtitle="Bu metin, 6698 sayılı KVKK kapsamında KolayYük uygulamasında işlenen kişisel verilere ilişkin aydınlatma yükümlülüğünü yerine getirmek amacıyla hazırlanmıştır."
    >
      {/* 1 */}
      <Section title="1. Amaç ve Kapsam">
        <p className={styles.p}>
          İşbu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu
          (“KVKK”) uyarınca, KolayYük mobil uygulamasını (“Uygulama”) kullanan
          kullanıcıların kişisel verilerinin hangi amaçlarla işlendiği, hangi
          hukuki sebeplere dayandığı, kimlere aktarılabileceği ve kullanıcıların
          hakları hakkında bilgilendirilmesi amacıyla hazırlanmıştır.
        </p>
        <p className={styles.p}>
          KolayYük, kullanıcıların yük ve taşıma bilgileri kapsamında
          birbirlerini bulmalarını kolaylaştıran bir dijital platform/MVP
          niteliğindedir. KolayYük; taşıma hizmeti sunmaz, taşıma sözleşmesinin
          tarafı değildir ve ödeme/komisyon süreçlerini yürütmez.
        </p>
      </Section>

      {/* 2 */}
      <Section title="2. Veri Sorumlusu">
        <p className={styles.p}>KVKK kapsamında veri sorumlusu:</p>
        <p className={styles.p}>
          <strong>Süleyman Kaan Büyükkatırcı</strong>
          <br />
          İletişim:{" "}
          <a className={styles.a} href="mailto:info@kolayyuk.com">
            info@kolayyuk.com
          </a>
        </p>
      </Section>

      {/* 3 */}
      <Section title="3. İşlenen Kişisel Veri Kategorileri">
        <ul className={styles.ul}>
          <li className={styles.li}>
            <strong>Kimlik/Profil Bilgileri:</strong> ad, soyad
          </li>
          <li className={styles.li}>
            <strong>İletişim Bilgileri:</strong> telefon numarası, (varsa) e-posta
          </li>
          <li className={styles.li}>
            <strong>Hesap ve Güvenlik Verileri:</strong> kullanıcı kimliği (uid),
            oturum/erişim doğrulamaya ilişkin kayıtlar
          </li>
          <li className={styles.li}>
            <strong>Teknik Veriler:</strong> cihaz türü, uygulama sürümü,
            hata/performans kayıtları
          </li>
          <li className={styles.li}>
            <strong>Bildirim Verileri:</strong> push token (örn. Expo Push Token)
          </li>
          <li className={styles.li}>
            <strong>Konum Verileri (izin verilirse):</strong> yaklaşık veya hassas konum
          </li>
          <li className={styles.li}>
            <strong>İçerik Verileri:</strong> ilan bilgileri, destek talepleri ve ekleri
          </li>
          <li className={styles.li}>
            <strong>Belge Verileri:</strong> taşıyıcı profili için yüklenen
            ehliyet/SRC/ruhsat vb. belgeler (yüklenirse)
          </li>
        </ul>

        <p className={styles.p}>
          KolayYük; ödeme bilgileri, kredi kartı verileri veya biyometrik veri işlemez.
        </p>
      </Section>

      {/* 4 */}
      <Section title="4. Kişisel Verilerin İşlenme Amaçları">
        <ul className={styles.ul}>
          <li className={styles.li}>Kullanıcı kaydı ve hesap yönetimi (telefon doğrulama dahil)</li>
          <li className={styles.li}>Uygulamanın temel fonksiyonlarının sağlanması (eşleştirme, ilanlar)</li>
          <li className={styles.li}>Bildirim gönderimi (yük güncellemeleri, sistem bildirimleri)</li>
          <li className={styles.li}>Destek taleplerinin alınması ve yanıtlanması</li>
          <li className={styles.li}>Güvenliğin sağlanması ve suistimalin önlenmesi</li>
          <li className={styles.li}>Hata tespiti, performans ölçümü ve hizmetin iyileştirilmesi</li>
        </ul>
      </Section>

      {/* 5 */}
      <Section title="5. Kişisel Verilerin Aktarılması">
        <ul className={styles.ul}>
          <li className={styles.li}>Google Firebase</li>
          <li className={styles.li}>Expo</li>
          <li className={styles.li}>Cloudflare</li>
        </ul>
        <p className={styles.p}>
          Bu hizmet sağlayıcılar kapsamında veriler yurt dışındaki sunucularda depolanabilir ve
          işlenebilir. Yasal zorunluluk halinde, yetkili kamu kurum ve kuruluşlarıyla paylaşım
          yapılabilir.
        </p>
      </Section>

      {/* 6 */}
      <Section title="6. Kişisel Veri Toplama Yöntemi">
        <p className={styles.p}>
          Kişisel veriler; uygulama üzerinden doğrudan kullanıcı tarafından sağlanması, uygulamanın
          kullanımı sırasında otomatik olarak oluşan teknik kayıtlar ve (varsa) destek talepleri
          yoluyla elektronik ortamda toplanır.
        </p>
      </Section>

      {/* 7 */}
      <Section title="7. Hukuki Sebepler">
        <ul className={styles.ul}>
          <li className={styles.li}>Sözleşmenin kurulması veya ifası için gerekli olması</li>
          <li className={styles.li}>Veri sorumlusunun meşru menfaati</li>
          <li className={styles.li}>Açık rıza (konum verisi ve yurt dışı aktarım gibi durumlar)</li>
        </ul>

        <p className={styles.p}>
          Uygulamanın performansının ölçülmesi ve hizmetin geliştirilmesi amacıyla,
          anonimleştirilmiş uygulama kullanım verileri analitik araçlar (örn. Firebase Analytics)
          kapsamında işlenebilir. Bu kapsamda yapılan işlemler, KVKK m.5 uyarınca veri sorumlusunun
          meşru menfaatine dayanmaktadır.
        </p>
      </Section>

      {/* 8 */}
      <Section title="8. Saklama Süresi">
        <p className={styles.p}>
          Kişisel veriler, işleme amaçları için gerekli süre boyunca saklanır. Hesap silme veya
          sürenin sona ermesi halinde veriler silinir, yok edilir veya anonim hale getirilir.
        </p>
      </Section>

      {/* 9 */}
      <Section title="9. KVKK Kapsamındaki Haklarınız">
        <p className={styles.p}>
          KVKK’nın 11. maddesi kapsamındaki taleplerinizi{" "}
          <a className={styles.a} href="mailto:info@kolayyuk.com">
            info@kolayyuk.com
          </a>{" "}
          adresi üzerinden iletebilirsiniz.
        </p>
      </Section>

      {/* 10 */}
      <Section title="10. Güncellemeler">
        <p className={styles.p}>
          Bu metin, mevzuat veya ürün kapsamındaki değişikliklere göre güncellenebilir. Güncel metin
          yayımlandığı tarihte yürürlüğe girer.
        </p>
      </Section>
    </LegalLayout>
  );
}

function Section({ title, children }) {
  return (
    <section className="mt-10">
      <h2 className="text-xl font-extrabold text-black">{title}</h2>
      <div className="mt-3">{children}</div>
    </section>
  );
}

const styles = {
  p: "text-gray-700 leading-relaxed mt-3",
  ul: "mt-3 ml-5 list-disc text-gray-700 leading-relaxed",
  li: "mt-2",
  a: "text-black underline underline-offset-4",
};
